export const SECTION_TYPES = {
  // global sections
  NAVBAR: "navbar",

  // home page sections
  HOME_HERO: "hero",
  ABOUT: "about",
  TESTIMONIALS: "testimonials",
  FAQS: "faqs",
  TEAM: "team",
  FINAL_CTA: "finalCta",
  SERVICES: "services",
  MAP: "map",
  OFFERS: "aboutOffers",
  OUR_PROCESS: "ourProcess",
  GEOTAGGED_PROJECTS: "geotaggedProjects",

  // service page sections
  SERVICE_HERO: "serviceHero",
  SERVICE_DETAILS: "serviceDetails",
  SERVICE_BENEFITS: "serviceBenefits",
  SERVICE_PROJECTS: "serviceProjects",

  // service area page sections
  SERVICE_AREA_HERO: "serviceAreaHero",
  SERVICE_AREA_MAP: "serviceAreaMap",
  SERVICE_AREA_FREE_FORM: "serviceAreaFreeForm",

  // about us page sections
  ABOUT_FREE_FORM: "aboutFreeForm",
  ABOUT_BENEFITS_AND_AWARDS: "aboutBenefitsAndAwards",

  // contact page sections
  CONTACT_FORM: "contactForm",
  FEATURED_TESTIMONIAL: "contactFeaturedTestimonial",

  // ppc page sections
  PPC_HERO: "ppcHero",
  PPC_WHY: "ppcWhy",
  PPC_OUR_PROCESS: "ppcOurProcess",
  PPC_TESTIMONIALS: "ppcTestimonials",
  PPC_OFFERINGS: "ppcOfferings",
  PPC_SERVICE_AREAS: "ppcServiceAreas",
  PPC_FAQS: "ppcFaqs",
  PPC_CTA: "ppcCta",

  // Misc sections.
  EMBEDDED_VIDEO: "embeddedVideo",
  SOCIAL_MEDIA_FEEDS: "socialMediaFeeds",
  PROJECTS: "projects",
  IFRAME: "iframe",
  FREE_FORM: "freeForm",
  VIDEO_HERO: "videoHero",
  PHOTO_CAROUSEL: "photoCarousel",
  BEFORE_AND_AFTER: "beforeAndAfter",
  FEATURES: "features",
  CREDENTIALS: "credentials",
  TEXT: "text",
  PARTNERSHIPS: "partnerships",
} as const;

export type SectionType = keyof typeof SECTION_TYPES;
